module.exports = __webpack_public_path__ + "static/media/Yungoos_gaussian2.6f3cad40.png";